(function(){
  if(window.__kyraLoadMore) return; window.__kyraLoadMore=true;
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-kyra-load-more]'); if(!btn) return;
    e.preventDefault();
    var wrap=btn.closest('[data-kyra-pagination]'), grid=document.getElementById('product-grid');
    var url=wrap&&wrap.getAttribute('data-next-url'); if(!url||!grid||btn.disabled) return;
    btn.disabled=true; var label=btn.textContent; btn.textContent='Cargando…';
    fetch(url,{credentials:'same-origin'}).then(function(r){ if(!r.ok) throw 0; return r.text(); }).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var items=doc.querySelectorAll('#product-grid > li');
      items.forEach(function(li){
        li.classList.remove('scroll-trigger','animate--slide-in','animate--fade-in');
        li.removeAttribute('data-cascade'); li.style.removeProperty('--animation-order');
        grid.appendChild(document.importNode(li,true));
      });
      var nw=doc.querySelector('[data-kyra-pagination]'), next=nw?nw.getAttribute('data-next-url'):'';
      var total=parseInt(wrap.getAttribute('data-total'),10)||grid.children.length;
      var sum=wrap.querySelector('[data-kyra-summary]');
      if(sum) sum.textContent='Mostrando 1–'+grid.children.length+' de '+total+' productos';
      var nav=wrap.querySelector('[data-kyra-nav]'); if(nav) nav.style.display='none';
      if(next){ wrap.setAttribute('data-next-url',next); btn.disabled=false; btn.textContent=label; }
      else { btn.remove(); }
      try{ history.replaceState(null,'',url); }catch(_){}
    }).catch(function(){ btn.disabled=false; btn.textContent=label; window.location.href=url; });
  });
})();
